export default "__VITE_ASSET__BoRMaXK2__"